import { Http } from '@/lib/http';

export class WatchlistService extends Http {
  constructor() {
    super();
    this.endpoint = '/aml-pro/app/watchlist';
  }

  fetchSources() {
    return this.httpClient().get(`${this.endpoint}/sources`);
  }

  fetchDashboardStats() {
    return this.httpClient().get(`${this.endpoint}/stats/dashboard`);
  }

  manualSearch(payload) {
    return this.httpClient().post(`${this.endpoint}/search/manual`, payload);
  }

  bulkSearch(payload) {
    return this.httpClient().post(`${this.endpoint}/search/bulk`, payload);
  }

  massSearch(payload = {}) {
    return this.httpClient().post(`${this.endpoint}/search/mass`, payload);
  }


  fetchSearchReports(params = {}) {
    return this.httpClient().get(`${this.endpoint}/search-reports`, { params });
  }

  fetchSearchReport(sessionId) {
    return this.httpClient().get(`${this.endpoint}/search-reports/${sessionId}`);
  }

  fetchFlags(params = {}) {
    return this.httpClient().get(`${this.endpoint}/flags`, { params });
  }

  fetchFlagsByAccount(accountId) {
    return this.httpClient().get(`${this.endpoint}/flags/account/${accountId}`);
  }

  fetchFlag(flagId) {
    return this.httpClient().get(`${this.endpoint}/flags/${flagId}`);
  }

  updateFlag(flagId, payload) {
    return this.httpClient().patch(`${this.endpoint}/flags/${flagId}`, payload);
  }

  setResearchOverride(flagId, reason) {
    return this.httpClient().patch(`${this.endpoint}/flags/${flagId}/allow-research`, { flagId, reason });
  }

  openCaseFromFlag(flagId, payload) {
    return this.httpClient().post(`${this.endpoint}/flags/${flagId}/open-case`, payload);
  }

  fetchSearchLogs(params = {}) {
    return this.httpClient().get(`${this.endpoint}/search-logs`, { params });
  }

  fetchSearchLogsByAccount(accountId, params = {}) {
    return this.httpClient().get(`${this.endpoint}/search-logs/account/${accountId}`, { params });
  }

  fetchCases(params = {}) {
    return this.httpClient().get(`${this.endpoint}/cases`, { params });
  }

  fetchCasesByAccount(accountId) {
    return this.httpClient().get(`${this.endpoint}/cases/account/${accountId}`);
  }

  fetchCase(caseId) {
    return this.httpClient().get(`${this.endpoint}/cases/${caseId}`);
  }

  closeCase(caseId, payload) {
    return this.httpClient().patch(`${this.endpoint}/cases/${caseId}/close`, payload);
  }

  assignCase(caseId, assignedToUserId) {
    return this.httpClient().patch(`${this.endpoint}/cases/${caseId}/assign`, { assignedToUserId });
  }

  deassignCase(caseId) {
    return this.httpClient().patch(`${this.endpoint}/cases/${caseId}/deassign`);
  }

  acknowledgeSearch(caseId) {
    return this.httpClient().patch(`${this.endpoint}/cases/${caseId}/acknowledge-search`);
  }

  addComment(caseId, payload) {
    return this.httpClient().post(`${this.endpoint}/cases/${caseId}/comments`, payload);
  }

  updateComment(caseId, commentId, message) {
    return this.httpClient().patch(`${this.endpoint}/cases/${caseId}/comments/${commentId}`, { message });
  }

  deleteComment(caseId, commentId) {
    return this.httpClient().delete(`${this.endpoint}/cases/${caseId}/comments/${commentId}`);
  }

  addAction(caseId, payload) {
    return this.httpClient().post(`${this.endpoint}/cases/${caseId}/actions`, payload);
  }

  updateAction(caseId, actionId, payload) {
    return this.httpClient().patch(`${this.endpoint}/cases/${caseId}/actions/${actionId}`, payload);
  }
}